import { Handle, Position } from "@xyflow/react";
import { useTranslation } from "react-i18next";
import { IconEdit, IconFileExport } from "@tabler/icons-react";

interface BankNodeData {
  id: string;
  name: string;
  balance: number;
  payableTotalAmount?: number;
  onEdit?: (id: string, name: string, balance: number) => void;
  onExport?: (id: string, name: string) => void;
}

interface BankNodeProps {
  data: BankNodeData;
  isConnectable: boolean;
}

function BankNode({ data, isConnectable }: BankNodeProps) {
  const { t } = useTranslation();

  const payableTotal = data.payableTotalAmount || 0;
  const isBalanceInsufficient = payableTotal > (data.balance || 0);

  return (
    <div
      className="p-4 rounded-lg bg-white shadow-md border-2 border-green-500"
      style={{ minWidth: "200px" }}
    >
      <Handle
        type="target"
        position={Position.Left}
        id="left"
        style={{ background: "#22c55e" }}
        isConnectable={isConnectable}
      />
      <Handle
        type="source"
        position={Position.Right}
        id="right"
        style={{ background: "#ef4444" }}
        isConnectable={isConnectable}
      />

      <div className="text-center">
        <div className="flex items-center justify-center gap-1">
          <div className="font-bold text-lg text-blue-600">{data.name}</div>
          <IconEdit
            size={16}
            className="cursor-pointer text-gray-400 hover:text-blue-500"
            onClick={() => data.onEdit?.(data.id, data.name, data.balance)}
          />
          <IconFileExport
            size={16}
            className="cursor-pointer text-gray-400 hover:text-green-500"
            onClick={() => data.onExport?.(data.id, data.name)}
          />
        </div>
        <div
          className={`mt-2 font-semibold ${isBalanceInsufficient ? "text-red-600" : "text-gray-600"}`}
        >
          {t("bank.balance") || "餘額"}: ${Math.round(data.balance || 0).toLocaleString()}
        </div>
        {isBalanceInsufficient && (
          <div className="text-xs text-red-500 mt-1">
            {t("bankManagement.insufficientBalance") || "餘額不足"}
          </div>
        )}
      </div>
    </div>
  );
}

export default BankNode;
